// extracted by mini-css-extract-plugin
module.exports = {"navItemsWrapper":"NavbarDesktop-module--navItemsWrapper--398ye","navbarDesktop":"NavbarDesktop-module--navbarDesktop--3XEj4"};